import { useState } from 'react';
import Header from '../assessor-directory/components/Header';
import Footer from '../assessor-directory/components/Footer';

const states = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

export default function StatesPage() {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredStates = states.filter(state =>
    state.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-800 to-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Browse All States
          </h1>
          <p className="text-xl text-slate-300 mb-8 max-w-3xl">
            Select a state to view all county assessor offices and appraisal districts. Access property records, tax assessments, and contact information.
          </p>
          
          {/* Search Bar */}
          <div className="max-w-2xl">
            <div className="relative">
              <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 text-xl"></i>
              <input
                type="text"
                placeholder="Search for a state..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-4 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-base"
              />
            </div>
          </div>
        </div>
      </section>

      {/* States Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filteredStates.map((state) => (
              <a
                key={state}
                href={`/assessor-directory?state=${encodeURIComponent(state)}`}
                className="bg-slate-800 border border-slate-700 rounded-lg p-6 hover:bg-slate-750 hover:border-emerald-500 transition-all cursor-pointer group"
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-white group-hover:text-emerald-400 transition-colors">
                    {state}
                  </h3>
                  <i className="ri-arrow-right-line text-slate-400 group-hover:text-emerald-400 transition-colors"></i>
                </div>
              </a>
            ))}
          </div>

          {filteredStates.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-search-line text-6xl text-slate-600 mb-4"></i>
              <p className="text-xl text-slate-400">No states found matching "{searchQuery}"</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
